module.exports = __webpack_public_path__ + "assets/radial-gradient.d0887db0.svg";